import React from "react";
import { Form } from "antd";

const RequiredFormItem = ({ label, rules = [], children, ...rest }) => {
    const isRequired = rules.some((rule) => rule?.required);

    const renderLabel = () => {
        if (!label) return label;

        return (
            <div className="RequiredFormItem">
                <span className="RequiredFormItem__Label">{label}</span>
                {isRequired && <span className="RequiredFormItem__Asterisk"> *</span>}
            </div>
        );
    };

    return (
        <Form.Item {...rest} label={renderLabel()} rules={rules}>
            {children}
        </Form.Item>
    );
};

export default RequiredFormItem;
